import { render, staticRenderFns } from "./MessageValidateCode.vue?vue&type=template&id=b42b7d04&scoped=true"
import script from "./MessageValidateCode.vue?vue&type=script&lang=js"
export * from "./MessageValidateCode.vue?vue&type=script&lang=js"
import style0 from "./MessageValidateCode.vue?vue&type=style&index=0&id=b42b7d04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42b7d04",
  null
  
)

export default component.exports